import * as yup from "yup";

export const DEFAULT_PERIOD_OPTIONS = [
  { value: "week", label: "過去1週間" },
  { value: "two_weeks", label: "過去2週間" },
  { value: "month", label: "過去1ヶ月" },
  { value: "three_months", label: "過去3ヶ月" },
] as const;

export type DefaultPeriod = (typeof DEFAULT_PERIOD_OPTIONS)[number]["value"];

const defaultPeriodValues = DEFAULT_PERIOD_OPTIONS.map((o) => o.value);

export interface AiAssistantTemplateFormValues {
  name: string;
  template: string;
  default_period: DefaultPeriod;
}

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("テンプレート名は必須です")
    .max(32, "テンプレート名は32文字以下で入力してください"),
  template: yup
    .string()
    .max(1500, "面談の背景・方針は1500文字以下で入力してください"),
  default_period: yup
    .string()
    .required()
    .oneOf([...defaultPeriodValues]),
});

export default validationSchema;
